// client/src/pages/Discover.jsx - 今日推荐：单卡片详情 + X/爱心
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import request from '../utils/request';
import GuestDetailContent from '../components/GuestDetailContent';
import { useWxShare } from '../hooks/useWxShare';
import { runMatchAfterSubscribe } from '../utils/wxSubscribeMatch';
import { AIMATCH_TAB_ACTIVATE } from '../utils/tabActivate';

const VIEWED_KEY = 'discover_viewed';
const MAX_VIEWED = 100;

function addToViewed(user) {
  try {
    let list = JSON.parse(localStorage.getItem(VIEWED_KEY) || '[]');
    list = list.filter((u) => u.id !== user.id);
    list.unshift({ ...user, viewedAt: Date.now() });
    list = list.slice(0, MAX_VIEWED);
    localStorage.setItem(VIEWED_KEY, JSON.stringify(list));
  } catch (e) {}
}

function Discover() {
  const [recommendations, setRecommendations] = useState([]);
  const [browse, setBrowse] = useState(null);
  const [gate, setGate] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [matchingUserId, setMatchingUserId] = useState(null);
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [matchMessage, setMatchMessage] = useState('');
  const navigate = useNavigate();

  const fetchRecommendations = useCallback(async (opts = {}) => {
    const silent = opts.silent === true;
    if (!silent) setLoading(true);
    try {
      const res = await request({ url: '/api/recommendations', method: 'GET' });
      setGate(null);
      const list = res.data?.list ?? res.data ?? [];
      setRecommendations(Array.isArray(list) ? list : []);
      setBrowse(res.data?.browse ?? null);
      setCurrentIndex(0);
    } catch (err) {
      if (err.response?.status === 403) {
        setGate({
          code: err.response?.data?.code,
          message: err.response?.data?.error || '无权浏览发现'
        });
        setRecommendations([]);
        setBrowse(null);
      } else {
        console.error('获取推荐失败:', err);
      }
    } finally {
      if (!silent) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRecommendations({ silent: false });
  }, [fetchRecommendations]);

  useEffect(() => {
    const onTab = (e) => {
      if (e.detail?.path === '/discover') fetchRecommendations({ silent: true });
    };
    window.addEventListener(AIMATCH_TAB_ACTIVATE, onTab);
    return () => window.removeEventListener(AIMATCH_TAB_ACTIVATE, onTab);
  }, [fetchRecommendations]);

  const currentUser = recommendations[currentIndex];

  useWxShare({
    title:
      currentUser && browse?.locked
        ? 'AI相亲助手 - 发现缘分'
        : currentUser
          ? `${currentUser.nickname || '嘉宾'} - AI相亲助手`
          : 'AI相亲助手 - 发现缘分',
    desc: browse?.locked ? '智能匹配，轻松脱单' : '智能匹配，轻松脱单。来发现你的 TA',
    imgUrl: browse?.locked ? undefined : currentUser?.avatar
  });

  const handleNext = () => {
    if (currentUser) {
      addToViewed(currentUser);
    }
    if (currentIndex + 1 < recommendations.length) {
      setCurrentIndex((i) => i + 1);
    } else {
      fetchRecommendations({ silent: true });
    }
  };

  const openMatchModal = () => {
    if (!currentUser) return;
    if (browse?.locked) {
      if (browse?.exhausted) {
        if (browse?.isMember) {
          alert('今日浏览次数已用完，明天再来吧');
        } else if (window.confirm('今日免费名额已用完（非会员每日 1 位）。开通会员可在有效期内每日查看 10 位异性，是否前往？')) {
          navigate('/membership');
        }
      }
      return;
    }
    addToViewed(currentUser);
    setMatchMessage('');
    setShowMatchModal(true);
  };

  const handleMatch = async (message) => {
    if (!currentUser) return;
    const token = localStorage.getItem('openid_token');
    const openid = localStorage.getItem('openid');
    if (!token && !openid) {
      alert('请先完善个人资料');
      navigate('/profile/edit');
      return;
    }
    const msg = (message || '').trim();
    if (msg && msg.length > 50) {
      alert('留言不能超过50个字');
      return;
    }
    setMatchingUserId(currentUser.id);
    try {
      await runMatchAfterSubscribe(async () => {
        const res = await request({
          url: '/api/match/request',
          method: 'POST',
          data: { targetId: currentUser.id, message: msg || undefined },
        });
        if (res.data?.success) {
          setShowMatchModal(false);
          alert(res.data.message || '已发送牵线请求，请等待对方同意');
          handleNext();
        }
      });
    } catch (err) {
      const errMsg = err.response?.data?.error || err.message || '牵线失败';
      if (err.response?.data?.needPay) {
        if (window.confirm('您没有可用名额，是否去购买会员？')) {
          setShowMatchModal(false);
          navigate('/membership');
        }
      } else {
        alert(errMsg);
      }
    } finally {
      setMatchingUserId(null);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="loading">加载中...</div>
      </Layout>
    );
  }

  if (gate) {
    return (
      <Layout>
        <div
          style={{
            margin: '-16px -16px 0 -16px',
            padding: '16px 16px 24px',
            minHeight: '100%',
            background: 'linear-gradient(180deg, #e8ecf9 0%, #ede9fe 50%, #f5f3ff 100%)',
          }}
        >
          <h2 style={{ marginBottom: 20 }}>🔍 今日推荐</h2>
          <div className="card" style={{ textAlign: 'center', padding: 36 }}>
            <p style={{ fontSize: 16, color: '#333', marginBottom: 24, lineHeight: 1.6 }}>{gate.message}</p>
            {gate.code === 'NEED_LOGIN' && (
              <button type="button" className="btn btn-primary" onClick={() => navigate('/profile/edit')}>
                去登录 / 注册
              </button>
            )}
            {(gate.code === 'NEED_PROFILE' || gate.code === 'NEED_REGISTER') && (
              <button type="button" className="btn btn-primary" onClick={() => navigate('/profile/edit')}>
                去完善资料
              </button>
            )}
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div
        style={{
          margin: '-16px -16px 0 -16px',
          padding: '16px 16px 24px',
          minHeight: '100%',
          background: 'linear-gradient(180deg, #e8ecf9 0%, #ede9fe 50%, #f5f3ff 100%)',
        }}
      >
        {/* 顶部：历史图标 */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ margin: 0 }}>🔍 今日推荐</h2>
          <button
            onClick={() => navigate('/discover/history')}
            title="历史"
            style={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              border: '1px solid #ddd',
              background: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              fontSize: 16,
            }}
          >
            📜
          </button>
        </div>

        {!currentUser ? (
          <div className="card" style={{ textAlign: 'center', padding: 40 }}>
            <p>{browse?.message || '暂无推荐嘉宾'}</p>
            <button
              className="btn btn-primary"
              style={{ marginTop: 16 }}
              onClick={() => fetchRecommendations({ silent: false })}
            >
              重新加载
            </button>
          </div>
        ) : (
          <>
            <div style={{ paddingBottom: 100 }}>
              <GuestDetailContent user={currentUser} browse={browse} />
            </div>

            {/* 底部：圆形 X 和 爱心（浮动固定） */}
            <div
              style={{
                position: 'fixed',
                bottom: 90,
                left: 0,
                right: 0,
                maxWidth: 500,
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'center',
                gap: 32,
                zIndex: 100,
              }}
            >
              <button
                onClick={handleNext}
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  border: 'none',
                  background: '#fff',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  fontSize: 28,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#999',
                }}
                title="下一个"
              >
                ✕
              </button>
              <button
                onClick={openMatchModal}
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  border: 'none',
                  background: browse?.locked ? '#ccc' : '#ff6b6b',
                  boxShadow: browse?.locked ? 'none' : '0 4px 12px rgba(255,107,107,0.4)',
                  fontSize: 28,
                  cursor: browse?.locked ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  opacity: browse?.locked ? 0.85 : 1,
                }}
                title={
                  browse?.locked && browse?.exhausted
                    ? browse?.isMember
                      ? '今日次数已用完'
                      : '今日名额已用完'
                    : '牵线'
                }
              >
                ❤
              </button>
            </div>
          </>
        )}
      </div>

      {/* 牵线留言弹窗 */}
      {showMatchModal && currentUser && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: 16,
          }}
          onClick={() => !matchingUserId && setShowMatchModal(false)}
        >
          <div className="card" style={{ maxWidth: 400, width: '100%' }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ marginBottom: 12 }}>向 {currentUser.nickname} 发起牵线</h3>
            <p style={{ color: '#666', fontSize: 14, marginBottom: 12 }}>留言（可选，最多50字）</p>
            <textarea
              value={matchMessage}
              onChange={(e) => setMatchMessage(e.target.value.slice(0, 50))}
              placeholder="想对 TA 说点什么..."
              maxLength={50}
              rows={3}
              style={{
                width: '100%',
                padding: 10,
                borderRadius: 8,
                marginBottom: 12,
                boxSizing: 'border-box',
                resize: 'vertical',
              }}
            />
            <p style={{ color: '#999', fontSize: 12, marginBottom: 16 }}>{matchMessage.length}/50</p>
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                className="btn btn-secondary"
                style={{ flex: 1 }}
                onClick={() => setShowMatchModal(false)}
                disabled={!!matchingUserId}
              >
                取消
              </button>
              <button
                className="btn btn-primary"
                style={{ flex: 1 }}
                onClick={() => handleMatch(matchMessage)}
                disabled={!!matchingUserId}
              >
                {matchingUserId ? '发送中...' : '发送'}
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default Discover;
